
<!--物流系统首页 -->
<template>
  <div class="is_home flex_row apphome">
    <!-- <leftcolumn class="app5760 flex_column"/> -->
    <div class="left flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">团队介绍</div>
          <div class="box tdbox">
            <div class="top">
              <DefTree v-bind:tree="treeDatas"></DefTree>
            </div>
            <div class="bottom">
              <NewList4></NewList4>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="mybox">
          <div class="title">配送及时率</div>
          <div class="box">
            <div id="is_bar1" class="echarts"></div>
          </div>
        </div>
        <div class="mybox">
          <div class="title">物流减排</div>
          <div class="box wljp">
            <div class="left">
              <div id="is_pie3" class="echarts"></div>
              <div class="text">
                <li>全年运输能源消耗：<b>{{fullYearPower}}</b>TCE</li>
                <li>全年减少碳排放：<b>{{fullYearLess}}</b>吨</li>
              </div>
            </div>
            <div class="right">
              <div class="top">
                <div class="title">安全趋势</div>
                <div id="is_line1" class="echarts"></div>
              </div>
              <div class="bottom">
                <div class="title">节能减排</div>
                <div id="is_bar2" class="echarts"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">物流网络</div>
          <div class="box realtime">
            <Amap  @amapDone="amapDone"  style="width: 100%;height: 100%;min-height: 5rem;" ref="Amap"></Amap>

            <!-- <RealTimeStatus/> -->
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="top flex_column">
          <div class="mybox">
            <div class="title">物流安全</div>
            <div class="box wlaqlist">
              <li>
                <span>车辆编号</span><span>车辆类型</span><span>品牌型号</span>
                <span>目标地址</span><span>客户名称</span><span>驾驶员</span><span>出发时间</span>
              </li>
              <div style="overflow: auto;">
                <p v-if="!wlaqlist.length" style="text-align: center;margin-top: 1rem;">暂无数据</p>

                <li v-for="(item, index) in wlaqlist" :key="index" @click="wlaqclick(item)">
                  <span><i class="el-icon el-icon-warning"></i>{{item.carModel}}</span>
                  <span>{{item.carType}}</span>
                  <span>{{item.carBand}}</span><span>{{item.trafficEnd}}</span>
                  <span>{{item.trafficCustom}}</span><span>{{item.driverName}}</span>
                  <span>{{item.trafficDepart}}</span>
                </li>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom flex_row">
          <div class="mybox">
            <div class="title">车辆里程排行榜</div>
            <div class="box">
              <div id="is_bar4" class="echarts"></div>
            </div>
          </div>
          <div class="mybox">
            <div class="title">车辆类型</div>
            <div class="box cltype">
              <div id="carType_pie" class="echarts"></div>
              <div class="text">
                <li>新能源车本月里程：<b>{{ vehicletypeData.mileage}}</b>KM</li>
                <li>减少二氧化碳排放：<b>{{ vehicletypeData.carbon}}</b>KG</li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right flex_column">
      <div class="mybox">
        <div class="title">车辆状态</div>
        <div class="box clstate">
          <div class="left">
            <div id="is_radar1" class="echarts"></div>
          </div>
          <div class="right">
            <li v-for="(item, index) in clslist" :key="index">
              {{item.name}}：{{item.value}}
            </li>
          </div>
        </div>
      </div>
      <div class="mybox">
        <div class="title">空闲车辆</div>
        <div class="box kxbox">
          <div id="is_pie1" class="echarts"></div>

          <div class="table">
            <vue-seamless-scroll :data="cltable" :class-option="{limitMoveNum: 5,direction: 1,step: 0.4,}">
              <li v-if="cltable.length==0">暂无数据</li>
              <li v-for="(item, index) in cltable" :key="index">
                <span>{{item.name}}</span><span>{{item.type}}</span>
                <span>{{item.num}}</span><span>{{item.user}}</span>
              </li>
            </vue-seamless-scroll>
          </div>

        </div>
      </div>
      <div class="mybox">
        <div class="title">人员状态</div>
        <div class="box kxbox">
          <div id="is_pie2" class="echarts"></div>
          <div class="table span1">
            <vue-seamless-scroll :data="rytable" :class-option="{limitMoveNum: 6,direction: 1,step: 0.4,}">

              <li v-for="(item, index) in rytable" :key="index">
                <span>{{item.driverName}}</span>

                <span v-if="item.status==1">空闲</span>
                <span v-if="item.status==2">忙碌</span>
                <span v-if="item.status==3">轮休</span>
                <span v-if="item.status==4">请假</span>

                <span>{{item.address}}</span>
                <span>{{item.carNum}}</span>
              </li>
            </vue-seamless-scroll>

          </div>
        </div>
      </div>
      <div class="mybox">
        <div class="title">物流提示</div>
        <div class="box wltslist">
          <li v-for="(item, index) in wltslist" :key="index">
            <span>{{item.time}}</span><span>{{item.name}}</span>
          </li>
        </div>
      </div>
    </div>
    <!-- <rightcolumn class="app5760 flex_column"/> -->

    <el-dialog :destroy-on-close='true' v-dialogDrag :visible.sync="wldialog" width="60%" title="异常车辆">
      <div class="wldialog">
        <el-row>
          <el-col :span="8">
            <div class="title">车辆信息</div>
            <div class="myform">
              <div><label>车辆类型：</label><span>{{wlaqValue.carType}}</span></div>
              <div><label>品牌型号：</label><span>{{wlaqValue.carBand}}</span></div>
              <div><label>车牌号：</label><span>{{wlaqValue.carModel}}</span></div>
              <div><label>载重/人量：</label><span>{{wlaqValue.carCarry}}</span></div>
              <div><label>购买日期：</label><span>{{wlaqValue.payTime?new Date(wlaqValue.payTime).Format("yyyy-MM-dd"):'--'}}</span></div>
              <div><label>年检状态：</label><span>{{wlaqValue.carInspect===1?'正常':'不正常'}}</span></div>
              <div><label>保险状态：</label><span>{{wlaqValue.carInsure}}</span></div>
              <div><label>当前里程：</label><span>{{wlaqValue.carMileage}}km</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="title">运输信息</div>
            <div class="myform">
              <div><label>起始地址：</label><span>{{wlaqValue.trafficStart}}</span></div>
              <div><label>目标地址：</label><span>{{wlaqValue.trafficEnd}}</span></div>
              <div><label>出发时间：</label><span>{{wlaqValue.trafficDepart}}</span></div>
              <div><label>预计到达：</label><span>{{wlaqValue.trafficArrive}}</span></div>
              <div><label>客户名称：</label><span>{{wlaqValue.trafficCustom}}</span></div>
              <div><label>业务联系人：</label><span>{{wlaqValue.trafficLink}}</span></div>
              <div><label>订单号：</label><span>{{wlaqValue.trafficOrder}}</span></div>
              <div><label>应交货日期：</label><span>{{wlaqValue.trafficDelivery}}</span></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="title">驾驶员信息</div>
            <div class="myform">
              <div><label>驾驶员：</label><span>{{wlaqValue.driverName}}</span></div>
              <div><label>年龄：</label><span>{{wlaqValue.driverDrivingAge}}</span></div>
              <div><label>联系电话：</label><span>{{wlaqValue.driverPhone}}</span></div>
              <div><label>紧急联系人：</label><span>{{wlaqValue.driverUrgentName}}</span></div>
              <div><label>紧急联系人电话：</label><span>{{wlaqValue.driverUrgentPhone}}</span></div>
              <div><label>驾驶执照：</label><span>{{wlaqValue.driverLicense}}</span></div>
              <div><label>驾驶年龄：</label><span>{{wlaqValue.driverAge}}</span></div>
              <div><label>本年度违章扣分：</label><span>{{wlaqValue.driverViolation}}</span></div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="title">实时视频</div>
            <div class="video">
              <!-- <div class="title1"><span>2020-05-09 12:14:25</span><span>川F87777</span></div> -->
              <video v-if="wlaqValue.liveVideo" height='100%' width='100%' :src="wlaqValue.liveVideo" controls>您的浏览器不支持 video 标签。</video>
              <img v-else src="../../assets/images/novideo.png" class="novideo">
            </div>
          </el-col>
          <el-col :span="8">
            <div class="title">回放视频</div>
            <div class="video">
              <video v-if="wlaqValue.backVideo" height='100%' width='100%' :src="wlaqValue.backVideo" controls>您的浏览器不支持 video 标签。</video>
              <img v-else src="../../assets/images/novideo.png" class="novideo">
            </div>
          </el-col>
          <el-col :span="8">
            <div class="title">异常事件</div>
            <div class="box">
              <p><span>事件：</span> {{wlaqValue.eventType}}</p>
              <p><span>位置：</span>{{wlaqValue.eventAddress}}</p>
              <p><span>时间：</span>{{wlaqValue.eventTime}}</p>
              <p><span>信息：</span>{{wlaqValue.eventInfo}}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api2 from '@/apis/IogisticsSystem'
import api from '@/apis/transportation/transportation'
let echarts = require('echarts/lib/echarts')
import DefTree from '@/components/TreeDefaultLog'
// import RealTimeStatus1 from "@/components/RealTimeStatus1";//实时状态
// import RealTimeStatus from "@/components/RealTimeStatus1";//实时状态
import NewList4 from '@/components/NewList4' //销售冠军
import vueSeamlessScroll from 'vue-seamless-scroll'
import Amap from './AMap'

// import leftcolumn from "@/views/CompanyProfile/leftcolumn.vue";
// import rightcolumn from "@/views/CompanyProfile/rightcolumn.vue";

export default {
  components: {
    Amap,
    // RealTimeStatus1,
    NewList4,
    DefTree,
    // RealTimeStatus,
    vueSeamlessScroll,
    // leftcolumn,
    // rightcolumn,
  },
  data() {
    return {
      timeliness: [
        //配送及时率
        [],
        [],
      ],
      wldialog: false,
      wlaqlist: [],
      wlaqValue: {},
      wltslist: [],
      clslist: [],
      cltable: [],
      rytable: [
        {
          address: '辽宁',
          carNum: '川F888667',
          driverName: '孙悟空',
          status: 2,
        },
      ],
      pie2data: [
        { value: 0, name: '空闲' },
        { value: 0, name: '忙碌' },
        { value: 0, name: '轮休' },
        { value: 0, name: '请假' },
      ],
      equipment_state: [
        { value: 47, name: '自有车辆' },
        { value: 25, name: '新能源车辆' },
      ],
      equipment_type: [
        { value: 32, name: '租赁车辆' },
        { value: 15, name: '客户自运' },
        { value: 14, name: '外包运货' },
        { value: 8, name: '自有车辆' },
      ],
      vehicletypeData: {
        carbon: '', //减少二氧化碳排放
        customSelfCar: '', //客户自运
        epibolyCar: '', //外包货运
        leaseCar: '', //租赁车辆
        mileage: '', //新能源车本月里程
        newEnergyCar: '', //新能源车数量
        ownCar: '', //自有车辆
      },
      fullYearPower: '', //全年运输能源消耗
      fullYearLess: '', //全年减少碳排放
      treeDatas: '', //树数据
    }
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    amapDone() {
      console.log('轨迹Amap加载完成！')
      this.$nextTick(()=>{
        this.$refs.Amap.replaying()
      })
    },

    //获取树数据
    getTreeLog() {
      api.getTeam().then((res) => {
        if (res.code == 10000) {
          if (res.data.length != 0) {
            this.treeDatas = res.data
          }
        }
      })
    },
    //获取物流减排
    getLessPower() {
      //安全趋势
      api.getReduct().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list[0]
          let _arr = [
            _data.oneSafe,
            _data.twoSafe,
            _data.threeSafe,
            _data.fourSafe,
            _data.fiveSafe,
            _data.sixSafe,
            _data.sevenSafe,
            _data.eightSafe,
            _data.nineSafe,
            _data.tenSafe,
            _data.elevenSafe,
            _data.twelveSafe,
          ]
          this.fullYearPower = _data.energyConsume
          this.fullYearLess = _data.reduCarbon
          this.is_line1(_arr)
          this.is_pie3(_data.newEnergy, _data.diesel, _data.gasoline)
        }
      })
      //节能减排
      api.getReductDown().then((data) => {
        if (data.code == 10000) {
          let _data = data.data
          let _year = []
          let _oil = []
          let _newPower = []
          for (var i in _data) {
            _year.push(_data[i].safeYear)
            _oil.push(_data[i].fuelTraffic)
            _newPower.push(_data[i].newEnergy)
          }
          this.is_bar2(_year, _oil, _newPower)
        }
      })
    },
    //获取车辆里程
    getCarKM() {
      api.getCarMile().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list
          let plate = []
          let lastMon = []
          let thisMon = []
          for (var i in _data) {
            plate.push(_data[i].carNum)
            lastMon.push(_data[i].mileageLast)
            thisMon.push(_data[i].mileage)
          }
          this.is_bar4(plate, lastMon, thisMon)
        }
      })
    },
    //获取车辆状态
    getCarStatus() {
      api.getCarStateList().then((res) => {
        if (res.code == 10000) {
          let _data = res.data[0]
          let _arr = [
            _data.idleNum,
            _data.afloatNum,
            _data.cargoNum,
            _data.returnNum,
            _data.loadingNum,
          ]
          this.is_radar1(_arr)
          this.clslist = [
            { id: 0, name: '空闲车辆', value: _data.idleNum },
            { id: 1, name: '在途车辆', value: _data.afloatNum },
            { id: 2, name: '卸货车辆', value: _data.cargoNum },
            { id: 3, name: '返回车辆', value: _data.returnNum },
            { id: 4, name: '装货车辆', value: _data.loadingNum },
          ]
          this.is_pie1('is_pie1', [
            { value: _data.idleNum, name: '空闲' },
            { value: _data.loadingNum, name: '装货' },
            { value: _data.afloatNum, name: '在途' },
            { value: _data.cargoNum, name: '卸货' },
            { value: _data.returnNum, name: '返回' },
          ])
        }
      })
      //列表
      api.getCarState('').then((data) => {
        if (data.code == 10000) {
          let _car = data.data.list
          let _carArr = _car.map((limit) => {
            return {
              id: limit.id,
              name: limit.carNum,
              type: limit.carBand,
              user: limit.driver,
              num: limit.carLoad.split('/')[0],
            }
          })
          this.cltable = _carArr
        }
      })
    },
    //获取物流提示
    getWLPropmt() {
      api.getNotify().then((res) => {
        if (res.code == 10000) {
          let _data = res.data.list
          let _arr = _data.map((item) => {
            return {
              id: item.id,
              name: item.eventContent,
              time: item.noteTime,
            }
          })
          this.wltslist = _arr
        }
      })
    },
    is_pie1(id, data) {
      let _that = this
      let is_pie1 = echarts.init(document.getElementById(id))
      is_pie1.setOption({
        color: ['#00ccff', '#24ffb1', '#f4af1b', '#f95458', '#ae74f3'],
        tooltip: {
          trigger: 'item',
          textStyle: { fontSize: this.$echartsFontSize },
        },
        legend: {
          left: 'center',
          top: -2,
          itemGap: 30,
          textStyle: {
            color: '#ccd0f2',
            fontSize: this.$echartsFontSize - 2,
          },
          itemWidth: 15,
          itemHeight: 15,
        },
        series: [
          {
            name: '类型',
            type: 'pie',
            radius: ['26%', '40%'],
            center: ['20%', '55%'],
            avoidLabelOverlap: true,
            // itemStyle: {
            //   borderRadius: 4,
            //   borderColor: '#081693',
            //   borderWidth: 2,
            // },
            label: {
              show: true,
              color: '#ccd0f2',
              fontSize: this.$echartsFontSize - 2,
              formatter: '{b}\n{num|{c}}',
              lineHeight: this.$echartsFontSize + 4,
              rich: {
                num: {
                  color: '#fff',
                  fontSize: this.$echartsFontSize,
                },
              },
            },
            data: data,
          },
        ],
      })
      is_pie1.on('click', pieConsole)
      function pieConsole(param) {
        let statuData = ['空闲', '装货', '卸货', '在途', '返回']
        let _index = statuData.indexOf(param.data.name)
        api.getCarState(_index + 1).then((data) => {
          if (data.code == 10000) {
            let _car = data.data.list
            let _carArr = _car.map((limit) => {
              return {
                id: limit.id,
                name: limit.carNum,
                type: limit.carBand,
                user: limit.driver,
                num: limit.carLoad.split('/')[0],
              }
            })
            _that.cltable = _carArr
          }
        })
      }
    },
    is_bar4(a1, a2, a3) {
      let is_bar4 = echarts.init(document.getElementById('is_bar4'))
      is_bar4.setOption({
        color: ['#00ccff', '#f4af1b'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          left: 'center',
          top: 10,
          itemGap: 30,
          textStyle: {
            color: '#fff',
            fontSize: this.$echartsFontSize,
          },
          itemWidth: 15,
          itemHeight: 5,
        },
        grid: {
          left: '30px',
          right: '30px',
          top: '35px',
          bottom: '15px',
          containLabel: false,
        },
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          show: false,
          data: a1,
        },
        series: [
          {
            name: '本月',
            type: 'bar',
            barWidth: '22%',
            itemStyle: {
              normal: {
                label: { show: false },
                barBorderRadius: [0, 12, 12, 0],
              },
            },
            data: a3,
          },
          {
            name: '上月',
            type: 'bar',
            barWidth: '22%',
            barGap: '10%',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: [10, '-6px'],
                  formatter: '{b}',
                  lineHeight: '15',
                  color: '#fff',
                  fontSize: this.$echartsFontSize + 4,
                  textShadowColor: '#000',
                  textShadowBlur: 4,
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
                barBorderRadius: [0, 12, 12, 0],
              },
            },
            data: a2,
          },
        ],
      })
    },
    //配送及时率
    is_bar1() {
      let is_bar1 = echarts.init(document.getElementById('is_bar1'))
      is_bar1.setOption({
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          left: 'center',
          top: '2%',
          itemGap: 30,
          textStyle: {
            color: this.legendTextColor,
            fontSize: this.$echartsFontSize,
          },
          itemWidth: 15,
          itemHeight: 5,
        },
        xAxis: {
          type: 'category',
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        },
        yAxis: {
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          // splitNumber:5, 
          nameGap:this.$echartsFontSize,
          splitLine:{show:true,lineStyle:this.splitLineStyle},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
        },
        grid: { left: '4%',right:'4%',top:'22%',bottom:'4%',containLabel: true},
        series: [
          {
            name: '去年',
            type: 'bar',
            barWidth: '15%',
            itemStyle: {
              normal: {
                color: '#00f2fe',
                barBorderRadius: [12, 12, 0, 0],
              },
            },
            data: this.timeliness[0], //[400, 400, 300, 300, 300, 400, 400, 400, 300, 300, 400, 400]
          },
          {
            name: '今年',
            type: 'bar',
            barWidth: '15%',
            itemStyle: {
              normal: {
                color: '#f5c74f',
                barBorderRadius: [12, 12, 0, 0],
              },
            },
            data: this.timeliness[1], //[400, 500, 500, 500, 500, 400,400, 500, 500, 300, 300, 400]
          },
        ],
      })
      this.$common.moveEcharts(12,is_bar1);
    },
    //节能减排
    is_bar2(a, b, c) {
      let is_bar2 = echarts.init(document.getElementById('is_bar2'))
      is_bar2.setOption({
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['#24ffb1', '#fff45c'],
        legend: {
          right: '1%',
          top: '5%',
          itemGap: 30,
          textStyle: {
            color: '#fff',
            fontSize: this.$echartsFontSize - 2,
          },
          itemWidth: 10,
          itemHeight: 10,
        },
        xAxis: {
          type: 'category',
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true},
          data: a,
        },
        yAxis: {
          axisLabel:{show:false,color:this.axisLabelColor,fontSize:this.$echartsFontSize},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          nameGap:this.$echartsFontSize,
          splitNumber:3, 
          splitLine:{show:true,lineStyle:this.splitLineStyle},
          axisTick: { show: false ,lineStyle:{color:this.axisLineColor}}
        },
        grid: { left: '2%',right:'4%',top:'25%',bottom:'2%',containLabel: true},
        series: [
          {
            name: '燃油',
            type: 'bar',
            barWidth: '15%',
            data: b,
          },
          {
            name: '新能源',
            type: 'bar',
            barWidth: '15%',
            data: c,
          },
        ],
      })
    },
    //安全趋势
    is_line1(a) {
      let is_line1 = echarts.init(document.getElementById('is_line1'))
      is_line1.setOption({
        color: ['#fff45c', '#24ffb1', '#00ccff', '#ff5f8c'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'cross',
          },
        },
        xAxis: {
          type: 'category',
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true},
        },
        yAxis: {
          axisLabel:{show:false,color:this.axisLabelColor,fontSize:this.$echartsFontSize},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          nameGap:this.$echartsFontSize,
          splitNumber:3, 
          splitLine:{show:true,lineStyle:this.splitLineStyle},
          axisTick: { show: false ,lineStyle:{color:this.axisLineColor}}
        },
        legend: { show: false },
        grid: { left: '2%',right:'4%',top:'30%',bottom:'4%',containLabel: true},
        series: [
          {
            name: '安全趋势',
            type: 'line',
            data: a,
            symbolSize: 0,
            symbol: 'circle',
          },
        ],
      })
    },
    is_radar1(t1) {


      var maxnum = Math.max(...t1)

      let is_radar1 = echarts.init(document.getElementById('is_radar1'))
      is_radar1.setOption({
        tooltip: {
          position: [20, 20],
          textStyle: { fontSize: this.$echartsFontSize },
        },
        radar: [
          {
            indicator: [
              { name: '空闲车辆', max: maxnum },
              { name: '在途车辆', max: maxnum },
              { name: '卸货车辆', max: maxnum },
              { name: '返回车辆', max: maxnum },
              { name: '装货车辆', max: maxnum },
            ],
            center: ['50%', '55%'], //中心点位置
            radius: '65%', //大小
            splitNumber: 5, //网线条
            shape: 'polygon', //多边形，circle圆形
            name: {
              //文字样式
              formatter: '{value}',
              fontSize: this.$echartsFontSize,
              textStyle: { color: '#ccd0f2' },
            },
            nameGap: 8,
            splitArea: {
              areaStyle: {
                color: [
                  'rgba(0, 204, 255, .6)',
                  'rgba(0, 204, 255, .5)',
                  'rgba(0, 204, 255, .4)',
                  'rgba(0, 204, 255, .3)',
                  'rgba(0, 204, 255, .2)',
                  'rgba(0, 204, 255, 0)',
                ], //大圆背景
              },
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(0, 204, 255, .5)', //线条颜色
              },
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 204, 255, 1)', //圆圈线条颜色
              },
            },
          },
        ],
        series: [
          {
            name: '车辆状态',
            type: 'radar',
            data: [
              {
                value: t1,
                symbol: 'rect',
                symbolSize: 0,
                areaStyle: {
                  normal: {
                    color: 'rgba(36, 255, 177, 0.5)',
                  },
                },
                lineStyle: {
                  normal: {
                    color: '#24ffb1',
                    width: 3,
                  },
                },
              },
            ],
          },
        ],
      })
    },
    carType_pie(state, type) {
      let is_pie = echarts.init(document.getElementById('carType_pie'))
      is_pie.setOption({
        color: [
          '#3570ff',
          '#f4af1b',
          '#00ccff',
          '#24ffb1',
          '#fff45c',
          '#ae74f3',
          '#ff5f8c',
        ],
        legend: {
          orient: 'vertical',
          right: '10%',

          icon: 'circle',
          top: 0,
          data: state,
          itemHeight: this.$echartsFontSize - 8,
          itemWidth: this.$echartsFontSize - 8,
          itemGap: 20,
          textStyle: {
            fontSize: this.$echartsFontSize,
            lineHeight: this.$echartsFontSize + 4,
            color: '#ccd0f2',
          },
          formatter: function (param) {
            let res = state.filter((v) => v.name === param)
            let percent = res[0].value
            return ' ' + param + `(${percent})`
          },
        },
        series: [
          {
            name: '车辆类型',
            type: 'pie',
            radius: [0, '40%'],
            center: ['35%', '50%'],
            label: { show: false },
            hoverAnimation: false,
            // itemStyle: { borderColor: '#0f26aa', borderWidth: 2 },
            data: state,
          },
          {
            name: '车辆类型',
            type: 'pie',
            radius: ['49%', '60%'],
            center: ['35%', '50%'],
            label: {
              formatter: '{b}\n{c}',
              lineHeight: this.$echartsFontSize + 4,
              fontSize: this.$echartsFontSize,
              color: '#ccd0f2',
            },
            // itemStyle: { borderColor: '#0f26aa', borderWidth: 2 },
            data: type,
          },
        ],
      })
    },
    is_pie3(a, b, c) {
      let is_pie3 = echarts.init(document.getElementById('is_pie3'))
      is_pie3.setOption({
        color: ['#3570ff', '#24ffb1', '#fff45c'],
        tooltip: {
          trigger: 'item',
          textStyle: { fontSize: this.$echartsFontSize },
        },
        legend: { show: false },
        series: [
          {
            name: '类型',
            type: 'pie',
            radius: ['18%', '30%'],
            center: ['50%', '32%'],
            avoidLabelOverlap: true,
            // itemStyle: {
            //   borderRadius: 4,
            //   borderColor: '#081693',
            //   borderWidth: 2,
            // },
            label: {
              show: true,
              color: '#ccd0f2',
              fontSize: this.$echartsFontSize - 2,
              formatter: '{b}\n{num|{d}%}',
              lineHeight: this.$echartsFontSize + 4,
              rich: {
                num: {
                  color: '#fff',
                  fontSize: this.$echartsFontSize,
                },
              },
            },
            data: [
              { value: a, name: '新能源用量' },
              { value: b, name: '柴油用量' },
              { value: c, name: '汽油用量' },
            ],
          },
        ],
      })
    },
    wlaqclick(item) {
      console.log(item)
      this.wlaqValue = item
      this.wldialog = true
    },
  },
  mounted() {
    this.getLessPower() //获取物流减排
    this.getCarKM() //获取车辆里程
    this.getCarStatus() //获取车辆状态
    this.getWLPropmt() //获取物流提示
    this.getTreeLog() //获取树数据
    this.$nextTick(() => {
      this.is_bar1() //配送及时率

      this.carType_pie(this.equipment_state, this.equipment_type) //车辆类型
      this.is_pie1('is_pie2', this.pie2data) //人员状态
    })

    //配送及时率
    api2
      .timeliness({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let dataArr = res.data.list
            for (const key in dataArr) {
              this.timeliness[key].push(dataArr[key].oneDis)
              this.timeliness[key].push(dataArr[key].twoDis)
              this.timeliness[key].push(dataArr[key].threeDis)
              this.timeliness[key].push(dataArr[key].fourDis)
              this.timeliness[key].push(dataArr[key].fiveDis)
              this.timeliness[key].push(dataArr[key].sixDis)
              this.timeliness[key].push(dataArr[key].sevenDis)
              this.timeliness[key].push(dataArr[key].eightDis)
              this.timeliness[key].push(dataArr[key].nineDis)
              this.timeliness[key].push(dataArr[key].tenDis)
              this.timeliness[key].push(dataArr[key].elevenDis)
              this.timeliness[key].push(dataArr[key].twelveDis)
            }
            this.is_bar1()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //车辆类型
    api2
      .vehicletype({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.vehicletypeData = res.data.list[0]
            this.equipment_state[0].value = this.vehicletypeData.ownCar
            this.equipment_state[1].value = this.vehicletypeData.newEnergyCar
            this.equipment_type[0].value = this.vehicletypeData.leaseCar
            this.equipment_type[1].value = this.vehicletypeData.customSelfCar
            this.equipment_type[2].value = this.vehicletypeData.epibolyCar
            this.equipment_type[3].value = this.vehicletypeData.ownCar
            this.carType_pie(this.equipment_state, this.equipment_type) //车辆类型
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //人员状态

    api2
      .statepersonnel({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            // console.log(res);
            this.rytable = res.data.list
            for (const iterator of this.rytable) {
              this.pie2data[iterator.status - 1].value++
            }
            this.is_pie1('is_pie2', this.pie2data) //人员状态
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //物流安全
    api2
      .logisticssafety({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.wlaqlist = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })



  },
}
</script>

<style lang="less" scoped>
.is_home {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      & > .top {
        flex: 1;
        height: 50%;
        overflow: hidden;
        .mybox {
          flex: 1;
          height: 100%;
          overflow: hidden;
        }
      }
      & > .bottom {
        flex: 1;
        height: 50%;
        overflow: hidden;
        .mybox {
          flex: 1;
          padding: 0.3rem 0;
          width: 50%;
          height: 100%;
          overflow: hidden;
        }
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  .realtime {
    position: relative;
  }
  .wlaqlist {
    display: flex;
    flex-direction: column;
    padding:0 0.4rem;
    li {
      // flex: 1;
      padding: 0.5rem 15px;
      cursor: pointer;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      i {
        color: #f4af1b;
        position: relative;
        top: 1px;
        margin-right: 10px;
        font-size: 0.9rem;
      }
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
      }
      span:nth-child(1) {
        width: 7rem;
        text-align: left;
      }
      span:nth-child(2) {
        width: 7rem;
      }
      span:nth-child(3) {
        flex: 1;
      }
      span:nth-child(4) {
        flex: 1;
      }
      span:nth-child(5) {
        flex: 1;
      }
      span:nth-child(6) {
        width: 5rem;
      }
      span:nth-child(7) {
        width: 8.5rem;
      }
    }
    div{
      li:nth-child(odd) {
      background: #ffffff10;
      }
      li:hover {
        color: #24ffb1;
      }
    }
  }
  .wltslist {
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    li {
      height: 2rem;
      padding: 0px 15px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      span:nth-child(1) {
        width: 8rem;
        text-align: left;
      }
      span:nth-child(2) {
        flex: 1;
      }
    }
    li:nth-child(even) {
      background: #ffffff10;
    }
    li:hover {
      color: #24ffb1;
    }
  }
  .tdbox{ display: flex; flex-direction: column;
    .top{ flex: 1; width: 100%; height: 100%; overflow: auto; display: flex; justify-content: center;}
    .bottom{ height: 12.5rem;}
  }
  .clstate {
    display: flex;
    flex-direction: row;
    .left {
      width: 60%;
    }
    .right {
      flex: 1;
      padding-left: 2rem;
      color: #24ffb1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      li {
        margin: 13px 0;
      }
    }
  }
  .kxbox {
    position: relative;
    padding: 0.6rem;
    .echarts {
      width: 100%;
    }
    .table {
      position: absolute;
      height: 74%;
      display: flex;
      flex-direction: column;
      top: 20%;
      right: 0.6rem;
      width: 55%;
      margin-left: 40%;
      // border: #0f2976 solid 1px;
      overflow: hidden;
      li {
        padding: 0.4rem 5px;
        // flex:1;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        &:nth-child(even){
          background-color: #ffffff10;
        }
        span {
          flex: 1;
          font-size: 0.7rem;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        span:nth-child(3) {
          flex: none;
          width: 3rem;
        }
        span:nth-child(4) {
          flex: none;
          width: 3.5rem;
        }
      }
      // li:last-child{border:none;}
      li:hover {
        color: #24ffb1;
      }
    }
    .table.span1 {
      li {
        span:nth-child(1) {
          flex: none;
          width: 3.5rem;
        }
        span:nth-child(2) {
          flex: none;
          width: 2rem;
        }
        span:nth-child(3) {
          flex: 1;
          width: auto;
        }
        span:nth-child(4) {
          flex: 1;
          width: auto;
        }
      }
    }
  }
  .cltype {
    position: relative;
    .text {
      position: absolute;
      
      right: 1rem;
      bottom: 0.2rem;
      width: 37%;
      li {
        margin: 0.3rem 0;
        font-size: 0.6rem;
        b {
          font-size: 1.2rem;
          margin-right: 5px;
          color: #24ffb1;
          font-family: 'DS-DIGI';
        }
      }
    }
  }
  .wljp {
    display: flex;
    flex-direction: row;
    .left {
      position: relative;
      width: 45%;
      .text {
        position: absolute;
        bottom: 1rem;
        width: 100%;
        li {
          margin: 0.3rem 0;
          font-size: 0.6rem;
          text-align: center;
          b {
            font-size: 1.2rem;
            margin-right: 5px;
            color: #24ffb1;
            font-family: 'DS-DIGI';
          }
        }
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      .top {
        height: 45%;
        position: relative;
      }
      .bottom {
        flex: 1;
        position: relative;
      }
      .title {
        position: absolute;
        top: 0.1rem;
        left: 0;
        color: #00ccff;
      }
    }
  }

  .wldialog {
    width: 100%;
    height: 100%;
    .video {
      border: #3570ff solid 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #071897;
      position: relative;
      width: 21.4rem;
      height: 15rem;
      overflow: hidden;
      .title1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1.6rem;
        line-height: 1.6rem;
        color: #fff;
        font-size: 0.55rem;
        padding: 0 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        // background-color: rgba(0,0,0,.3);
        background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
      }
      video {
        width: 100%;
        height: 100%;
      }
      img.novideo {
        width: 50%;
      }
    }
    .title {
      background: #3570ff;
      color: #fff;
      font-size: 0.75rem;
      padding: 0 6px 2px;
      display: inline-block;
      margin-bottom: 20px;
    }
    .el-row {
      margin-bottom: 60px;
    }
    .myform {
      display: flex;
      flex-direction: row;
      width: auto;
      padding: 0.5rem;
      flex-wrap: wrap;
      border: #555e86 dashed 1px;
      margin-right: 2rem;
      & > div {
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 8px 10px;
        label {
          width: 6rem;
          text-align: right;
          margin-right: 10px;
          flex-shrink: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #fff;
        }
      }
    }
    .box {
      padding: 0.5rem;
      height: 15rem;
      overflow-y: auto;
      border: #555e86 dashed 1px;
      margin-right: 2rem;
    }
  }
}
</style>
